import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { PercentageofbreakEditService } from '../../service/percentageofbreak-edit/percentageofbreak-edit.service';

@Component({
	selector: 'app-percentageofbreak-edit',
	templateUrl: './percentageofbreak-edit.component.html',
	providers: [
		PercentageofbreakEditService,
		HttpModule
	]
})
export class PercentageofbreakEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	percentForm: FormGroup;
	ID: string;
	Porcentagem: string;
	Ativo: boolean;

	constructor(fb: FormBuilder, private percentageofbreakEditService: PercentageofbreakEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.percentForm = fb.group({
			'ID': '',
			'Porcentagem': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.percentageofbreakEditService.loadPercent(this.token, this.ID).subscribe(result => {
				var updatePercent = result.Result;
				this.percentForm.setValue({
					ID: updatePercent.ID,
					Porcentagem: updatePercent.Porcentagem,
					Ativo: updatePercent.Ativo
				});
			})
		}, error => {
			console.log(error);

		});
	}

	editPercent(value: any) {
		this.percentageofbreakEditService.editPercent(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Percentual de Quebra editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/porcentagem-quebra');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/porcentagem-quebra');
	}

}



// WEBPACK FOOTER //
// ./src/app/percentageofbreak/component/percentageofbreak-edit/percentageofbreak-edit.component.ts